import { GithubFacade, SupportedSyncTypes } from '@mode/github/contract';
import { ModeForm } from '@mode/shared/contract-common';
import { Action, createReducer, on } from '@ngrx/store';
import * as GithubSyncDialogActions from './github-sync-dialog/github-sync-dialog.actions';
import * as GithubActions from './github.actions';

export const GITHUB_FEATURE_KEY = 'github';

export interface GithubState {
  syncType: SupportedSyncTypes | null;
  syncToGithubForm: ModeForm | null | undefined;
  githubLink: string | null | undefined;
  lastRunAt: string | null;
  lastSavedAt: string | null;
  lastSuccessfulSyncAt: string | null;
  syncTargetToken: string | null;
  syncTargetName: string | null;
  workspace: string | null;
  error?: string | null; // last known error (if any)
}

export const initialGithubState: GithubState = {
  syncType: null,
  syncToGithubForm: null,
  githubLink: null,
  lastRunAt: null,
  lastSavedAt: null,
  lastSuccessfulSyncAt: null,
  syncTargetToken: null,
  syncTargetName: null,
  workspace: null,
  error: null,
};

const reducer = createReducer(
  initialGithubState,
  on(GithubFacade.Actions.datasetEditorHeaderGithubSyncInitialized, (state) => ({
    ...state,
    syncType: SupportedSyncTypes.Dataset,
  })),
  on(GithubFacade.Actions.definitionEditorHeaderGithubSyncInitialized, (state) => ({
    ...state,
    syncType: SupportedSyncTypes.Definition,
  })),
  on(GithubFacade.Actions.reportEditorHeaderGithubSyncInitialized, (state) => ({
    ...state,
    syncType: SupportedSyncTypes.Report,
  })),
  on(GithubFacade.Actions.datasetEditorHeaderPushedChangesToGithub, (state) => ({ ...state, error: null })),
  on(GithubFacade.Actions.reportEditorHeaderPushedChangesToGithub, (state) => ({ ...state, error: null })),
  on(GithubSyncDialogActions.githubSyncDialogChangesPushed, (state) => ({ ...state, error: null })),
  on(GithubSyncDialogActions.githubSyncDialogPushSucceeded, (state) => ({
    ...state,
    lastSuccessfulSyncAt: new Date().toString(),
    error: null,
  })),
  on(GithubSyncDialogActions.githubSyncDialogPushFailed, (state, { error }) => ({ ...state, error })),
  on(GithubActions.githubSyncContextChanged, (state, { context }) => ({
    ...state,
    error: null,
    ...context,
  }))
);

export function githubReducer(state: GithubState | undefined, action: Action) {
  return reducer(state, action);
}
